export const newsCategories = [
    {
        id: 0,
        name: 'all',
        label: "All"
    },
    {
        id: 1,
        name: 'business',
        label: 'Business'
    },
    {
        id: 2,
        name: 'entertainment',
        label: 'Entertainment'
    },
    {
        id: 3,
        name: 'health',
        label: 'Health'
    },
    {
        id: 4,
        name: 'science',
        label: 'Science'
    },
    {
        id: 5,
        name: 'sports',
        label: 'Sports'
    },
    {
        id: 6,
        name: 'technology',
        label: 'Technology'
    }
]